export default function OneDriveEmbed({ embedUrl, title = 'PDF document' }) {
  if (!embedUrl) {
    return <p>PDF原本リンクは準備中です。</p>;
  }

  return (
    <iframe
      title={title}
      src={embedUrl}
      className="pdf-frame"
      loading="lazy"
      allow="fullscreen"
    />
  );
}
